import React from 'react';
import './UserAvatar.css';

/**
 * UserAvatar component - displays user initials or image
 * @param {string} name - User's full name (e.g., "Eduardo Cervantes")
 * @param {string} imageUrl - Optional image URL (null for initials)
 * @param {string} size - Size of avatar: 'small', 'medium', 'large' (default: 'medium')
 * @param {string} status - Online status: 'online', 'offline', 'away', null (default: null)
 */
const UserAvatar = ({ name, imageUrl = null, size = 'medium', status = null }) => {
    // Get initials from name
    const getInitials = (fullName) => {
        if (!fullName) return '?';
        const names = fullName.trim().split(' ');
        if (names.length === 1) {
            return names[0].charAt(0).toUpperCase();
        }
        return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
    };

    // Generate color based on name for consistency
    const getAvatarColor = (fullName) => {
        if (!fullName) return '#6c757d';

        const colors = [
            '#667eea', // Purple
            '#2962ff', // Blue
            '#4bc0c0', // Teal
            '#f093fb', // Pink
            '#36a2eb', // Light blue
            '#43e97b', // Green
            '#f5576c', // Red
            '#764ba2', // Dark purple
        ];

        // Use first letter to consistently pick a color
        const charCode = fullName.charCodeAt(0);
        return colors[charCode % colors.length];
    };

    const initials = getInitials(name);
    const backgroundColor = getAvatarColor(name);

    return (
        <div className={`user-avatar-wrapper ${size}`}>
            {imageUrl ? (
                // Show image if URL is provided
                <img
                    src={imageUrl}
                    alt={name}
                    className="user-avatar-image"
                />
            ) : (
                // Show initials if no image
                <div
                    className="user-avatar-initials"
                    style={{ backgroundColor }}
                >
                    {initials}
                </div>
            )}
            {status && (
                <span className={`profile-status ${status}`}></span>
            )}
        </div>
    );
};

export default UserAvatar;
